"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentCompleteDisplayFormat = exports.PercentCompleteFieldLogic = void 0;
var percent_complete_fieldtype_1 = require("./percent-complete.fieldtype");
Object.defineProperty(exports, "PercentCompleteFieldLogic", { enumerable: true, get: function () { return percent_complete_fieldtype_1.PercentCompleteFieldLogic; } });
var percent_complete_model_1 = require("./percent-complete.model");
Object.defineProperty(exports, "PercentCompleteDisplayFormat", { enumerable: true, get: function () { return percent_complete_model_1.PercentCompleteDisplayFormat; } });
